import React from 'react';
import { observer } from 'mobx-react-lite';

import { isCompanyDomain } from '@src/helpers';
import { useStore } from '@src/models';
import { BaseLink, Link, StyledLinkProps } from 'src/kit';

export const DefaultPrivateRouteLink = observer(function DefaultPrivateRouteLink(props: StyledLinkProps) {
  const { authStore, userStore } = useStore();

  if (!authStore.isAuthorized || (userStore.isEmployer && !isCompanyDomain())) {
    return <BaseLink href={userStore.defaultPrivateRoute} {...props} />;
  }
  return <Link to={userStore.defaultPrivateRoute} {...props} />;
});
